import { Grid, Box, Typography } from "@mui/material";
type DetailsInfoProps = {
  title: string;
  value?: string | null;
  paddingLeft?: boolean;
  onClickEditIcon?: () => void;
  tooltipTextEditButton?: string;
  valueWidth?: number | string;
  removePaddingInMobile?: boolean;
  onChange?: (value: string) => void;
  type?: string;
  justifyContent?: string;
};
export function DetailsInfo(props: DetailsInfoProps) {
  return (
    <Grid item>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: {
            xs:
              !props.removePaddingInMobile && props.paddingLeft
                ? "35px"
                : "0px",
            sm: "0px",
          },
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "0.8rem",
          }}
        >
          {props.title}
        </Typography>

        <Typography
          sx={{
            fontSize: "0.9rem",
            width: props.valueWidth,
            textAlign: "left",
          }}
        >
          {props.value ?? "Não informado"}
        </Typography>
      </Box>
    </Grid>
  );
}
